import { Observable } from 'rxjs';
import {
  CHECK_MISSING_DOCUMENTS,
  CREATE_NEW_FORM,
  EDIT_EXISTING_FORM,
  GENERATE_FORM_101_AS_PDF,
  GET_CITIES,
  DOWNLOAD_FORM_119,
  GET_FORM101_AS_PDF,
  GET_FORM101_DATA,
  GET_FORM_HEADERS,
  GET_SETTLEMENTS,
  REINIT_AUTHENTICATION_TOKEN,
  SAVE_AS_DRAFT,
  SUBMIT_FORM,
  UPDATE_USER_OFFICE,
  COMPARE_EMPLOYEE_DETAILS,
  DELETE_FORM_WITH_CHANGES,
} from '@/types/form.types';
import { $httpClient } from '@/services/httpClient';
import { map } from 'rxjs/operators';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { City } from '@/models/form/PersonalDetails.model';
import { Form101DataResponse } from '@/models/form/Form101DataResponse.model';
import { FormHeaders } from '@/models/Form.model';
import { LoginResponse } from '@/models/response/LoginResponse';
import { Form119DataResponse } from '@/models/form/Form119DataResponse';
import { FormDetailsChangedResponse } from '@/models/response/FormDetailsChangedResponse';

export default class FormService {
  private readonly baseApi: string;
  private readonly lobbyBaseApi: string;

  constructor() {
    this.baseApi = 'api/emp/form/';
    this.lobbyBaseApi = 'api/emp/lobby/';
  }

  public getFormHeaders(): Observable<FormHeaders> {
    return $httpClient.get<FormHeaders>(this.baseApi + GET_FORM_HEADERS)
      .pipe(
        map((formHeaders: FormHeaders) => {
          return {
            results: formHeaders.formHeaders || [],
            resultCount: formHeaders.formHeaders!.length,
          } as FormHeaders;
        }),
      );
  }

  public getFormData(formId: number): Observable<Form101DataResponse> {
    return $httpClient.get<Form101DataResponse>(this.baseApi + GET_FORM101_DATA + '?formId=' + formId);
  }

  public getDownload119Form(): Observable<Form119DataResponse> {
    return $httpClient.get<Form119DataResponse>(this.baseApi + DOWNLOAD_FORM_119);
  }

  public editExistingForm(formId: number): Observable<number> {
    return $httpClient.post<number>(this.baseApi + EDIT_EXISTING_FORM + '?formId=' + formId);
  }

  public compareEmployeeDetails(formId: number): Observable<FormDetailsChangedResponse> {
    return $httpClient.post<FormDetailsChangedResponse>(this.baseApi + COMPARE_EMPLOYEE_DETAILS + '?formId=' + formId);
  }

  public deleteFormWithChanges(formId: number): Observable<number> {
    return $httpClient.post<number>(this.baseApi + DELETE_FORM_WITH_CHANGES + '?formId=' + formId);
  }

  public createNewForm(taxYear: number): Observable<Form101DataResponse> {
    return $httpClient.post<Form101DataResponse>(this.baseApi + CREATE_NEW_FORM + '?taxYear=' + taxYear);
  }

  public submitForm(password: string, effectiveDate: Date, formData: Form101DataModel): Observable<Form101DataModel> {
    return $httpClient.post<Form101DataModel>(this.baseApi + SUBMIT_FORM, { password, effectiveDate, formData });
  }

  public saveAsDraft(formData: Form101DataModel): Observable<Form101DataModel> {
    return $httpClient.post<Form101DataModel>(this.baseApi + SAVE_AS_DRAFT, { formData });
  }

  public checkMissingDocuments(formData: Form101DataModel): Observable<Form101DataModel> {
    return $httpClient.post<Form101DataModel>(this.baseApi + CHECK_MISSING_DOCUMENTS, { formData });
  }

  public getCitiesList(taxYear: number): Observable<City[]> {
    return $httpClient.get<City[]>(this.baseApi + GET_CITIES + '?taxYear=' + taxYear)
      .pipe(
        map((data: any) => {
          return data.cities;
        }),
      );
  }

  public getSettlementsList(taxYear: number): Observable<City[]> {
    return $httpClient.get<City[]>(this.baseApi + GET_SETTLEMENTS + '?taxYear=' + taxYear)
      .pipe(
        map((data: any) => {
          return data.settlements;
        }),
      );
  }

  public getForm101AsPdf(docId: number): Observable<any> {
    return $httpClient.get(this.baseApi + GET_FORM101_AS_PDF + '?docId=' + docId);
  }

  public generateForm101AsPdf(formId: number): Observable<any> {
    return $httpClient.get(this.baseApi + GENERATE_FORM_101_AS_PDF + '?formId=' + formId);
  }

  public updateUserOffice(officeNum: number, formId: number): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.lobbyBaseApi + UPDATE_USER_OFFICE, { officeNum, formId });
  }

  public reinitAuthenticationToken(): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.lobbyBaseApi + REINIT_AUTHENTICATION_TOKEN);
  }
}
